import { hot } from "react-hot-loader/root";
import React from "react";
import PropTypes from "prop-types";

import "./AppleMusic.scss";

class PlayerTime extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrubbing: false,
      scrubbingPosition: 0
    };

    this.onStartScrubbing = this.onStartScrubbing.bind(this);
    this.onEndScrubbing = this.onEndScrubbing.bind(this);
    this.onScrub = this.onScrub.bind(this);

    this.getCurrentPlaybackDuration = this.getCurrentPlaybackDuration.bind(
      this
    );
    this.getCurrentPlaybackTime = this.getCurrentPlaybackTime.bind(this);

    // this.getCurrentBufferedProgress = this.getCurrentBufferedProgress.bind(
    //   this
    // );

    this.music = MusicKit.getInstance();
  }

  getCurrentPlaybackDuration() {
    // return this.getTime(
    //   this.props.music.player.currentPlaybackTimeRemaining * 1000
    // );
    return 7.8;
    // return this.music.player.currentPlaybackTimeRemaining * 1000;
  }

  getCurrentPlaybackTime() {
    return 3.23;
  }

  getScrubberValue() {
    // console.log("getScrubberValue");

    if (this.state.isScrubbing) {
      return this.state.scrubbingPosition;
    }

    if (this.props.music.player) {
      return this.props.music.player.currentPlaybackTime;
    }

    return 0;
  }

  onScrub(e) {
    // console.log("onScrub");
    this.setState({
      scrubbingPosition: e.target.value
    });
  }

  onStartScrubbing(e) {
    this.setState({
      isScrubbing: true,
      scrubbingPosition: e.target.value
    });
  }

  async onEndScrubbing(e) {
    await this.props.music.player.seekToTime(e.target.value);

    this.setState({
      isScrubbing: false,
      scrubbingPosition: null
    });
  }

  render() {
    return (
      <div className="am__scrub">
        <div className="am__scrub__progress_bar">{this.renderProgress()}</div>
      </div>
    );
  }

  getDuration() {
    if (!this.props.mediaItem) {
      return 0;
    }

    return this.props.music.isAuthorized
      ? this.props.mediaItem.attributes.durationInMillis / 1000
      : 30;
  }

  timeToPercent(time, duration) {
    if (duration === 0) {
      return 0; // For some reason would call this
    }

    return Math.floor((time * 100) / duration);
  }

  getCurrentBufferedProgress() {
    return this.props.music.player.currentBufferedProgress;
  }

  renderProgress() {
    const bufferPercent = this.props.music
      ? this.getCurrentBufferedProgress()
      : 0;

    let styles = {};

    const duration = this.getDuration();

    const percent = this.props.music
      ? this.timeToPercent(
          this.props.music.player.currentPlaybackTime,
          duration
        )
      : 0;

    const light_grey = "#dadae1";
    const dark_grey = "#a4aab3";

    return (
      <input
        className="progress_bar"
        style={{
          background: `linear-gradient(
            to right,
            ${dark_grey} 0%,
            ${dark_grey} ${percent}%,
            ${light_grey} ${percent}%,
            ${light_grey} ${bufferPercent}%,
            #eeeeee ${bufferPercent}%,
            #eeeeee 100%
          ) no-repeat`
        }}
        type={"range"}
        value={this.getScrubberValue()}
        onChange={this.onScrub}
        onMouseDown={this.onStartScrubbing}
        onTouchStart={this.onStartScrubbing}
        onMouseUp={this.onEndScrubbing}
        onTouchEnd={this.onEndScrubbing}
        min={0}
        max={duration}
        step={1}
      />
    );
  }

  getTime(ms) {
    if (!ms || isNaN(ms)) {
      ms = 0;
    }
    const s = 1000 * Math.round(ms / 1000);
    const d = new Date(s);

    return `${d.getUTCMinutes()}:${String(`0${d.getUTCSeconds()}`).slice(-2)}`;
  }
}

export default hot(PlayerTime);
